module.exports = __webpack_public_path__ + "img/mail-box-5.29cf53ec.png";